var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQecSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14286 7C1.14286 3.72878 3.95707 1.07692 7.42857 1.07692C8.57442 1.07692 9.64705 1.36535 10.571 1.869C10.8442 2.0179 11.1938 1.92994 11.3518 1.67252C11.5098 1.4151 11.4164 1.08571 11.1433 0.936805C10.05 0.340892 8.78069 0 7.42857 0C3.32588 0 0 3.13401 0 7C0 10.866 3.32588 14 7.42857 14C11.5313 14 14.8571 10.866 14.8571 7C14.8571 6.70262 14.6013 6.46154 14.2857 6.46154C13.9701 6.46154 13.7143 6.70262 13.7143 7C13.7143 10.2712 10.9001 12.9231 7.42857 12.9231C3.95707 12.9231 1.14286 10.2712 1.14286 7Z",
    fill: "#5C5E69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8326 1.99613C16.0558 1.78585 16.0558 1.44492 15.8326 1.23463C15.6095 1.02435 15.2477 1.02435 15.0245 1.23463L7.42857 8.39235L4.40406 5.54233C4.1809 5.33205 3.8191 5.33205 3.59594 5.54233C3.37278 5.75261 3.37278 6.09354 3.59594 6.30383L7.02451 9.5346C7.24767 9.74488 7.60948 9.74488 7.83263 9.5346L15.8326 1.99613Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQecSvg);
export default __webpack_public_path__ + "static/media/qec-svg.0cf9c74238be8c4fcbc8ff3734d81419.svg";
export { ForwardRef as ReactComponent };